// ============================================
// 蛋糕外卖小程序 - 全局模拟数据
// ============================================

export interface CakeItem {
  id: number
  name: string
  description: string
  minPrice: number
  maxPrice: number
  priceLabel: string
  image: string
  category: string
  style: string
  tags: string[]
  rating: number
  monthlySales: number
  isHot: boolean
  isNew: boolean
  isSeasonal: boolean
  sizes?: string[]
  flavors?: string[]
}

export interface Coupon {
  id: string
  name: string
  type: '满减' | '折扣' | '免运费'
  value: number
  minAmount: number
  threshold: number
  startTime: string
  endTime: string
  used: boolean
}

export interface OrderItem {
  cakeId: number
  name: string
  image: string
  size: string
  taste: string
  sugar: string
  price: number
  quantity: number
  isCustom: boolean
  customText?: string
}

export interface Order {
  orderNo: string
  status: '待付款' | '制作中' | '配送中' | '已完成' | '已取消'
  items: OrderItem[]
  totalPrice: number
  freight: number
  discount: number
  payAmount: number
  payMethod: string
  address: string
  receiverName: string
  receiverPhone: string
  deliverySlot: string
  remark: string
  createdAt: string
  couponId?: string
}

// ---- 蛋糕数据 ----
export const MOCK_CAKES: CakeItem[] = [
  {
    id: 1, name: '草莓之恋', description: '新鲜草莓搭配轻柔奶油，清甜不腻，适合浪漫场合',
    minPrice: 128, maxPrice: 148, priceLabel: '128~148', image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: 'ins风', tags: ['热卖', '经典'],
    rating: 4.9, monthlySales: 856, isHot: true, isNew: false, isSeasonal: false,
  },
  {
    id: 2, name: '巧克力梦', description: '比利时进口巧克力，浓郁丝滑，巧克力控必入',
    minPrice: 148, maxPrice: 148, priceLabel: '148', image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: 'ins风', tags: ['热卖'],
    rating: 4.8, monthlySales: 723, isHot: true, isNew: false, isSeasonal: false,
  },
  {
    id: 3, name: '抹茶物语', description: '日式宇治抹茶与奶油完美融合，清新淡雅',
    minPrice: 138, maxPrice: 138, priceLabel: '138', image: 'https://images.unsplash.com/photo-1519869325930-281384150729?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: '极简风', tags: ['新品'],
    rating: 4.7, monthlySales: 412, isHot: false, isNew: true, isSeasonal: false,
  },
  {
    id: 4, name: '芒果慕斯', description: '菲律宾芒果手工制作慕斯，入口即化',
    minPrice: 158, maxPrice: 158, priceLabel: '158', image: 'https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: 'ins风', tags: ['热卖', '人气'],
    rating: 4.9, monthlySales: 967, isHot: true, isNew: false, isSeasonal: false,
  },
  {
    id: 5, name: '榴莲忘返', description: '马来西亚猫山王榴莲果肉，榴莲控的天堂',
    minPrice: 198, maxPrice: 198, priceLabel: '198', image: 'https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: 'ins风', tags: ['招牌'],
    rating: 4.8, monthlySales: 534, isHot: false, isNew: false, isSeasonal: false,
  },
  {
    id: 6, name: '红丝绒之吻', description: '经典红丝绒蛋糕配奶油芝士霜，情人节限定',
    minPrice: 168, maxPrice: 168, priceLabel: '168', image: 'https://images.unsplash.com/photo-1588195538326-c5b1e9f80a1b?w=400&h=400&fit=crop',
    category: '情人节蛋糕', style: '复古风', tags: ['限定', '浪漫'],
    rating: 4.9, monthlySales: 389, isHot: false, isNew: false, isSeasonal: true,
  },
  {
    id: 7, name: '小熊乐园', description: '可爱翻糖小熊装饰，宝宝最爱的生日蛋糕',
    minPrice: 188, maxPrice: 188, priceLabel: '188', image: 'https://images.unsplash.com/photo-1535141192574-5d4897c12571?w=400&h=400&fit=crop',
    category: '儿童节蛋糕', style: '卡通风', tags: ['亲子', '可爱'],
    rating: 4.7, monthlySales: 623, isHot: false, isNew: false, isSeasonal: false,
  },
  {
    id: 8, name: '樱花限定', description: '春季限定樱花口味，粉嫩颜值满分',
    minPrice: 178, maxPrice: 178, priceLabel: '178', image: 'https://images.unsplash.com/photo-1562440499-64c9a111f713?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: '新中式', tags: ['季节限定', '高颜值'],
    rating: 4.8, monthlySales: 267, isHot: false, isNew: true, isSeasonal: true,
  },
  {
    id: 9, name: '提拉米苏', description: '意式经典，马斯卡彭芝士与可可粉的完美组合',
    minPrice: 138, maxPrice: 138, priceLabel: '138', image: 'https://images.unsplash.com/photo-1571115177098-24ec42ed204d?w=400&h=400&fit=crop',
    category: '下午茶', style: '复古风', tags: ['经典', '小资'],
    rating: 4.6, monthlySales: 445, isHot: false, isNew: false, isSeasonal: false,
  },
  {
    id: 10, name: '黑森林', description: '德式经典，黑巧克力与樱桃的经典搭配',
    minPrice: 148, maxPrice: 148, priceLabel: '148', image: 'https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: '复古风', tags: ['经典'],
    rating: 4.5, monthlySales: 334, isHot: false, isNew: false, isSeasonal: false,
  },
  {
    id: 11, name: '企业定制蛋糕', description: '支持企业LOGO定制，适合年会、庆典、活动',
    minPrice: 298, maxPrice: 298, priceLabel: '298', image: 'https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=400&h=400&fit=crop',
    category: '企业定制', style: '极简风', tags: ['企业', '定制'],
    rating: 4.9, monthlySales: 128, isHot: false, isNew: false, isSeasonal: false,
  },
  {
    id: 12, name: '水果缤纷', description: '6种时令水果铺满蛋糕，维生素满满',
    minPrice: 168, maxPrice: 168, priceLabel: '168', image: 'https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=400&h=400&fit=crop',
    category: '生日蛋糕', style: 'ins风', tags: ['热卖', '健康'],
    rating: 4.7, monthlySales: 789, isHot: true, isNew: false, isSeasonal: false,
  },
]

// ---- Banner 数据 ----
export const MOCK_BANNERS = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=800&h=360&fit=crop',
    title: '春季新品上市',
    subtitle: '樱花限定蛋糕 · 满减优惠中',
    link: '/cake/8',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=800&h=360&fit=crop',
    title: '生日蛋糕专场',
    subtitle: '满99减20 · 满199减50',
    link: '/menu?category=生日蛋糕',
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1519869325930-281384150729?w=800&h=360&fit=crop',
    title: '定制你的专属蛋糕',
    subtitle: '口味/尺寸/装饰 · 一键定制',
    link: '/customize',
  },
]

// ---- 分类数据 ----
export const MOCK_CATEGORIES = [
  { id: 1, name: '生日蛋糕', icon: '🎂', count: 8 },
  { id: 2, name: '情人节蛋糕', icon: '💕', count: 1 },
  { id: 3, name: '儿童节蛋糕', icon: '🧸', count: 1 },
  { id: 4, name: '企业定制', icon: '🏢', count: 1 },
  { id: 5, name: '下午茶', icon: '☕', count: 1 },
]

// ---- 优惠券 ----
export const MOCK_COUPONS: Coupon[] = [
  { id: 'cpn1', name: '新人满减券', type: '满减', value: 20, minAmount: 99, threshold: 99, startTime: '2026-01-01', endTime: '2026-12-31', used: false },
  { id: 'cpn2', name: '生日特惠券', type: '满减', value: 50, minAmount: 199, threshold: 199, startTime: '2026-01-01', endTime: '2026-12-31', used: false },
  { id: 'cpn3', name: '免运费券', type: '免运费', value: 0, minAmount: 0, threshold: 0, startTime: '2026-01-01', endTime: '2026-12-31', used: false },
  { id: 'cpn4', name: '全场9折券', type: '折扣', value: 10, minAmount: 0, threshold: 0, startTime: '2026-01-01', endTime: '2026-12-31', used: false },
]

// ---- 默认地址 ----
export const MOCK_ADDRESSES = [
  {
    id: 'addr1',
    province: '湖南省', city: '湘潭市', district: '岳塘区',
    detail: '建设南路88号万达广场3楼',
    receiverName: '张三', phone: '13800138001', isDefault: true,
  },
  {
    id: 'addr2',
    province: '湖南省', city: '湘潭市', district: '雨湖区',
    detail: '基建营步步高商场北门',
    receiverName: '张三', phone: '13800138001', isDefault: false,
  },
]

// ---- 历史订单 ----
export const MOCK_ORDERS: Order[] = [
  {
    orderNo: 'CK20260420001', status: '已完成',
    items: [
      { cakeId: 1, name: '草莓之恋', image: MOCK_CAKES[0].image, size: '8寸', taste: '水果味', sugar: '半糖', price: 192, quantity: 1, isCustom: false },
    ],
    totalPrice: 200, freight: 0, discount: 20, payAmount: 180, payMethod: '微信支付',
    address: '湖南省湘潭市岳塘区建设南路88号万达广场3楼',
    receiverName: '张三', receiverPhone: '13800138001',
    deliverySlot: '14:00-15:00', remark: '请放前台',
    createdAt: '2026-04-20 14:30:00', couponId: 'cpn1',
  },
  {
    orderNo: 'CK20260421001', status: '配送中',
    items: [
      { cakeId: 4, name: '芒果慕斯', image: MOCK_CAKES[3].image, size: '6寸', taste: '水果味', sugar: '正常糖', price: 158, quantity: 1, isCustom: false },
      { cakeId: 9, name: '提拉米苏', image: MOCK_CAKES[8].image, size: '6寸', taste: '芝士味', sugar: '正常糖', price: 138, quantity: 1, isCustom: false },
    ],
    totalPrice: 296, freight: 8, discount: 0, payAmount: 304, payMethod: '微信支付',
    address: '湖南省湘潭市雨湖区基建营步步高商场北门',
    receiverName: '张三', receiverPhone: '13800138001',
    deliverySlot: '16:00-17:00', remark: '',
    createdAt: '2026-04-21 10:15:00',
  },
]

// ---- 帮助函数 ----
export function getCakeById(id: number): CakeItem | undefined {
  return MOCK_CAKES.find(c => c.id === id)
}

export function searchCakes(keyword?: string, category?: string, style?: string, taste?: string, sortBy?: string): CakeItem[] {
  let result = [...MOCK_CAKES]

  if (keyword) {
    const kw = keyword.toLowerCase()
    result = result.filter(c =>
      c.name.toLowerCase().includes(kw) ||
      c.description.toLowerCase().includes(kw) ||
      c.tags.some(t => t.includes(kw))
    )
  }
  if (category) result = result.filter(c => c.category === category)
  if (style) result = result.filter(c => c.style === style)
  if (taste) result = result.filter(c => c.taste === taste)

  switch (sortBy) {
    case 'sales': result.sort((a, b) => b.monthlySales - a.monthlySales); break
      case 'price-asc': result.sort((a, b) => a.minPrice - b.minPrice); break
      case 'price-desc': result.sort((a, b) => b.minPrice - a.minPrice); break
    case 'rating': result.sort((a, b) => b.rating - a.rating); break
    default: break
  }

  return result
}
